
import { Component, Vue } from "vue-property-decorator";

import boothsPositionsDirective from "./positioning-directives/booths-directive";
import api from "@/network/api";
import { AxiosResponse } from "axios";

@Component({
  directives: {
    boothsPositionsDirective,
  },
})
export default class BoothsPage extends Vue {
  private boothsFilter: any = [];
  private boothsData: any = [];
  private boothPath: any = "";
  private boothType: any = "";
  ready = false;

  public get screenValues(): {
    height: number;
    width: number;
  } {
    return {
      height: this.windowWidth * 0.45,
      width: window.innerWidth,
    };
  }

  created() {
    api.get("booths").then((res: AxiosResponse) => {
      this.boothPath = this.$route.path;
      if (this.boothPath == "/booths_games") {
        this.boothType = ["game"];
      } else {
        this.boothType = ["lesson","interactive lesson"];
      }
      this.boothsFilter = res.data.data;
      this.boothsFilter.forEach((item: any) => {
        if (this.boothType.includes(item.type)) {
          this.boothsData.push(item);
        }
      });
      this.ready = true;
    });
  }

  goto(path: string) {
    this.$router.push("/" + path);
  }
}
